import ManageEmployerFilesList from './manage-employer-file-list';

export default ManageEmployerFilesList;